import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import {
    checkMeService,
    loginService,
    logoutService,
    refreshToken,
} from '../../service/api/loginService';
import { message } from 'antd';
import { getStoreLocal, removeStoreLocal, saveToken } from '../../utils/localStore';

export const checkMe = createAsyncThunk('checkMe', async (data, thunkAPI) => {
    const access_token = getStoreLocal('access_token');
    const time_access = getStoreLocal('time_access');
    const refresh_token = getStoreLocal('refresh_token');
    const time_refresh = getStoreLocal('time_refresh');

    if (!access_token || !time_access || !refresh_token || !time_refresh) {
        return thunkAPI.rejectWithValue('Không thấy access token');
    }

    let decoded;
    decoded = jwtDecode(access_token);
    if (parseInt(time_access) < Date.now()) {
        if (parseInt(time_refresh) < Date.now())
            return thunkAPI.rejectWithValue('Refresh Token hết hạn');

        const resNewToken = await refreshToken(refresh_token, data.redirectUri);
        decoded = jwtDecode(resNewToken?.access_token);
    } else {
        decoded = jwtDecode(access_token);
    }
    try {
        const resData = await checkMeService(decoded.sub);
        return resData;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const login = createAsyncThunk('login', async (data, thunkAPI) => {
    const { code, redirectUri } = data;
    const resData = await loginService({ code, redirectUri });
    return resData;
});

export const logout = createAsyncThunk('logout', async (data, thunkAPI) => {
    const { refreshToken } = data;
    const resData = await logoutService({ refreshToken });
    return resData;
});

// export const changePassword = createAsyncThunk(
//   "changePassword",
//   async (data, thunkAPI) => {
//     const { id, password } = data;
//     // const resData = await changePasswordService(id, { password });
//     return resData;
//   }
// );

const initialState = {
    isLogin: false,
    user: null,
    loading: false,
    role: [],
};

export const LoginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        logOut: (state) => {
            removeStoreLocal('access_token');
            removeStoreLocal('refresh_token');
            removeStoreLocal('time_refresh');
            removeStoreLocal('time_access');
            removeStoreLocal('keycloakId');
            state.isLogin = false;
            state.user = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // checkMe cases
            .addCase(checkMe.pending, (state) => {
                state.loading = true;
            })
            .addCase(checkMe.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
                localStorage.setItem('account_web', JSON.stringify(action.payload));
                // state.role = action.payload?.role.map((item) => item.name);
                state.isLogin = true;
            })
            .addCase(checkMe.rejected, (state, action) => {
                state.loading = false;
                console.log('Reject', action.error);
            })
            // login cases
            .addCase(login.pending, (state) => {
                // Handle login pending if needed
            })
            .addCase(login.fulfilled, (state, action) => {
                saveToken(action.payload);
            })
            .addCase(login.rejected, (state, action) => {
                message.error(` Hệ thống đang có lỗi, vui lòng thử lại sau `);
            })
            // logout cases
            .addCase(logout.pending, (state) => {
                // Handle logout pending if needed
            })
            .addCase(logout.fulfilled, (state, action) => {
                // Handle logout success if needed
            })
            .addCase(logout.rejected, (state, action) => {
                // Handle logout error if needed
            });
    },
});

// Action creators are generated for each case reducer function
export const { logOut } = LoginSlice.actions;
export default LoginSlice.reducer;
